import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";
import { persistSession } from "../utils/tokenStorage";
import { revokeRefreshToken } from "./refreshAuth";

export { refreshSession } from "./refreshAuth";

export const login = async ({ username, password }) => {
  const response = await axiosClient.post("/api/auth/login", {
    username,
    password,
  });
  const data = unwrapApiResponse(response);

  if (data?.requiresMfa) {
    const error = new Error(response.data?.message || "Additional verification is required.");
    error.requiresMfa = true;
    error.challengeToken = data.challengeToken;
    throw error;
  }

  if (!data?.accessToken || !data?.refreshToken) {
    throw new Error("Login did not return access and refresh tokens.");
  }

  persistSession({
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    user: data.user,
  });

  return data;
};

export const logout = async () => {
  await revokeRefreshToken();
};

export const getMe = async () => {
  const response = await axiosClient.get("/api/auth/me");
  return unwrapApiResponse(response);
};
